import { render, staticRenderFns } from "./VettingEdit.vue?vue&type=template&id=3a61ae6a"
import script from "./VettingEdit.vue?vue&type=script&lang=js"
export * from "./VettingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports